module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Medium-af80b5cba92bfb5dcde7c731cab07332.svg";